import { loadLazyImages } from "../utilities/globalUtilities";

const dynamicImports = () => {
    // Dynamic import for the publicoads
    import(
        /* webpackMode: "lazy" */
        "../lib/js/publicoads.js"
    ).then(module => {
        const PublicoIntegration = new module.Publico();
        PublicoIntegration.init();
    }).catch(error => `An error occurred while loading the component: ${error}`);
    // Adding default lazy loading and the fallback for lazysizes
    (async () => {
        if ("loading" in HTMLImageElement.prototype) {
            loadLazyImages();
        } else {
            // Dynamically import the LazySizes library
            await import("../lib/js/lazysizes.min.js");
            // Initiate LazySizes (reads data-src & class=lazyload)

            // lazySizes works off a global.
            lazySizes.init(); // eslint-disable-line
        }
    })();
};

const initDynamicImports = () => {
    if (document.readyState == "complete") {
        dynamicImports();
    } else {
        window.addEventListener("load", () => {
            dynamicImports();
        });
    }
};

export { initDynamicImports };
